import React from "react";
import { Link } from "react-router-dom";

//images
import footerImg from "./../assets/footerImg.jpg";
import { MdEmail } from "react-icons/md";
import { FaPhoneSquareAlt } from "react-icons/fa";

const TIKTOK_URL = "https://www.tiktok.com/@kelownaductcleani";
const INSTAGRAM_URL = "https://www.instagram.com/kelownaductcleaning?igsh=eDhzNzZpYnJmNnhk&utm_source=qr";
const PHONE = "2508996660";
const PHONE_LINK = "tel:+12508996660";
const EMAIL = "Cleanairkelowna@gmail.com";

function Footer() {
  return (
    <>
      <footer className="site-footer style-1" id="footer">
        <div
          className="footer-top background-luminosity"
          style={{ backgroundImage: "url(" + footerImg + ")" }}
        >
          <div className="container">
            <div className="row">
              <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                <div className="widget widget_services">
                  <h4 className="widget-title">Quick Links</h4>
                  <ul>
                    <li><Link to={"/"}>Home</Link></li>
                    <li><Link to={"/about-us"}>About Us</Link></li>
                    <li><Link to={"/services"}>Services</Link></li>
                    <li><Link to={"/why-us"}>Why Us</Link></li>
                    <li><Link to={"/#gallery"}>Gallery</Link></li>
                    <li><Link to={"/#faq"}>FAQs</Link></li>
                    <li><Link to={"/contact-us"}>Contact Us</Link></li>
                    <li><Link to={"/contact-us"}>Quote</Link></li>
                  </ul>
                </div>
              </div>
              <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                <div className="widget recent-posts-entry">
                  <h4 className="widget-title">Contact Details</h4>
                  <div className="widget-post-bx">
                    <div className="widget-post clearfix">
                      <div className="dz-info">
                        <h6 className="title"><FaPhoneSquareAlt /> Phone</h6>
                        <span className="post-date" style={{ fontWeight: "400", color: "white" }}>
                          <a href={PHONE_LINK} style={{ fontWeight: "400", color: "white" }}>
                            {PHONE.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3")}
                          </a>
                        </span>
                      </div>
                    </div>
                    <div className="post-separator"></div>
                    <div className="widget-post clearfix">
                      <div className="dz-info">
                        <h6 className="title"><MdEmail /> Email</h6>
                        <span className="post-date">
                          <a href={`mailto:${EMAIL}`} style={{ fontWeight: "400", color: "white" }}>
                            {EMAIL}
                          </a>
                        </span>
                      </div>
                    </div>
                    <div className="post-separator"></div>
                    <div className="widget-post clearfix">
                      <div className="dz-info">
                        <h6 className="title">Social media</h6>
                        <div className="dz-social-icon transparent space-10">
                          <ul>
                            <li>
                              <a
                                target="_blank"
                                rel="noopener noreferrer"
                                className="fab fa-instagram"
                                href={INSTAGRAM_URL}
                                aria-label="Instagram"
                                style={{ fontWeight: "400", color: "white" }}
                              />
                            </li>
                            <li>
                              <a
                                target="_blank"
                                rel="noopener noreferrer"
                                className="fab fa-tiktok"
                                href={TIKTOK_URL}
                                aria-label="TikTok"
                                style={{ fontWeight: "400", color: "white" }}
                              />
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-bottom text-center">
          <div className="container">
            <span className="copyright-text">
              Copyright © 2025 – 2026{" "}
              <Link to="/">Kelowna Duct Cleaning</Link>
              . All rights reserved.
            </span>
          </div>
        </div>
      </footer>
    </>
  );
}
export default Footer;
